import RestService from '../services/rest';

async function getFamilies(limit, skip, search, order = '', field = '') {
  return RestService.getAuthenticated(
    `panel/families?limit=${limit}&skip=${skip}&search=${search}&order=${order}&field=${field}`,
  );
}

async function getFamily(id) {
  return RestService.getAuthenticated(`panel/families/${id}`);
}

async function createFamily(family) {
  return RestService.postAuthenticated('panel/families/create', family);
}

async function updateFamily(family) {
  return RestService.putAuthenticated('panel/families/update', family);
}

async function deleteFamily(id) {
  return RestService.postAuthenticated('panel/families/delete', { id });
}

export default {
  getFamilies,
  getFamily,
  createFamily,
  updateFamily,
  deleteFamily,
};
